// extracted by mini-css-extract-plugin
export default {"container":"UserStatus_container__T5iQB"};